<template>
  <label
    class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    :for="htmlId"
  >EXTRA BARS</label>
  <br />
  <input
    type="text"
    placeholder=""
    :id="htmlId"
    class="sc3-text-input sc3-text-input-inline sc3-text-input-slim sc3-text-input-compact sc3-text-input-grey-and-black"
    :class="{
      'sc3-text-input-invalid': !isRangeExtraBarsValid
    }"
    v-model="rangeExtraBars"
    ref="rangeExtraBarsInputElement"
    @blur="syncChartStoreRangeExtraBars()"
    @keyup.enter="handleEnterKeyUpRangeExtraBars()"
    autocomplete="off"
  />
</template>

<script lang="ts" setup>
  import { ref, computed, watch, toRefs } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useChartStore } from '@/stores/chartStore';
  import { isValidRangeExtraBars } from '@/composables/isValidRangeExtraBars';

  const chartStore = useChartStore();
  const { rangeExtraBars: chartStoreRangeExtraBars } = storeToRefs(chartStore);
  const props = defineProps<{
    htmlId: string;
  }>();
  const { htmlId } = toRefs(props);
  const rangeExtraBars = ref(chartStoreRangeExtraBars.value === 0 ? '' : chartStoreRangeExtraBars.value.toString());
  const rangeExtraBarsInputElement = ref<HTMLElement>();
  const isRangeExtraBarsValid = computed(() => {
    return isValidRangeExtraBars(rangeExtraBars.value);
  });

  function syncChartStoreRangeExtraBars() {
    if (!isRangeExtraBarsValid.value) {
      rangeExtraBars.value = chartStoreRangeExtraBars.value === 0 ? '' : chartStoreRangeExtraBars.value.toString();
      return;
    }

    const rangeExtraBarsString = rangeExtraBars.value.trim();
    const rangeExtraBarsNumber = !rangeExtraBarsString ? 0 : Number(rangeExtraBarsString);

    if (rangeExtraBarsNumber === 0) {
      rangeExtraBars.value = '';
    }

    chartStore.$patch({ rangeExtraBars: rangeExtraBarsNumber });
  }

  function handleEnterKeyUpRangeExtraBars() {
    rangeExtraBarsInputElement.value?.blur();
  }

  function handleChartStoreRangeExtraBarsChanged() {
    rangeExtraBars.value = chartStoreRangeExtraBars.value === 0 ? '' : chartStoreRangeExtraBars.value.toString();
  }

  watch(chartStoreRangeExtraBars, handleChartStoreRangeExtraBarsChanged);
</script>
